export default __webpack_public_path__ + "static/media/Baobab_MCF_Logo_whiteHeading.f6e7b750.svg";